<template>
  <RTE
    :content="mgnlProps.content"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { RTEBuilder, WrapperProps } from './RTE.model';
import RTE from './RTE.vue';

const props = defineProps(WrapperProps);
const mgnlProps = RTEBuilder.build(props);
</script>
